import getParent from "@/utils/getParent";
import { merge } from "lodash";
import reporter from "../report/reporter";
import { getSearchData } from "../shared/getSearchData";
import { getPage } from "../shared/global";
import { MutiMng } from "./expose";
import { getAttribute, getCommonData, getFilter } from "./get";

const ContainerMng = new MutiMng({
  dataKey: "board_id",
  key: "board_source",
  reporterKeys: {
    ids: "board_ids",
    number: "board_number",
  },
  extKeys: [
    { key: "board_location", reporterKey: "board_locations" },
    { key: "board_dist_code", reporterKey: "board_dist_codes" },
  ],
});

export function board_expose(targetNode) {
  const page = getPage();

  const trackData = {
    event_id: 33007,
    event_name: "board_expose",
    board_id: targetNode.getAttribute("data-board-id"),
    board_location: targetNode.getAttribute("data-board_location"),
    ...page,
  };

  const { page_nm, sub_page_nm } = page;
  var sourceNode =
    (targetNode.hasAttribute("data-content-source") && targetNode) ||
    getParent(targetNode, "[data-content-source]");

  if (sourceNode) {
    trackData.board_source = `${page_nm}_${
      sub_page_nm || ""
    }_${sourceNode.getAttribute("data-content-source")}`;
  } else {
    trackData.board_source = `${page_nm}_${sub_page_nm || ""}`;
  }

  if (page_nm === "专题页") {
    const el = document.querySelector("[data-topic-id]");
    if (el) {
      trackData.topic_title = el.getAttribute("data-topic-title");
      trackData.topic_id = el.getAttribute("data-topic-id");
    }
  }

  getCommonData(targetNode, trackData);

  // 计算聚合 key：联合 board_source 和 module_name，用于区分不同的聚合容器
  // 但上报时保持 board_source 和 module_name 为独立字段
  if (trackData.module_name) {
    trackData._aggregateKey = `${trackData.board_source}_${trackData.module_name}`;
    trackData._originalBoardSource = trackData.board_source; // 保存原始的 board_source，用于上报
  }

  const dist_code = getAttribute(targetNode, "data-board-dist-code");
  if (dist_code) {
    trackData.board_dist_code = dist_code;
  }

  merge(trackData, getFilter(page.page_nm, targetNode));

  if (page_nm === "搜索结果页") {
    getSearchData(trackData);
  }

  const search_word = getAttribute(targetNode, "data-search-word");
  if (search_word) {
    trackData.search_word = search_word;
  }

  if (page_nm === "采集详情页" && trackData.search_word) {
    getSearchData(trackData);
  }

  ContainerMng.add(trackData);
}

export function board_click(targetNode) {
  const page = getPage();

  const trackData = {
    event_id: 33008,
    event_name: "board_click",
    board_id: targetNode.getAttribute("data-board-id"),
    board_location: targetNode.getAttribute("data-board_location"),
    ...page,
  };

  const { page_nm, sub_page_nm } = page;
  var sourceNode =
    (targetNode.hasAttribute("data-content-source") && targetNode) ||
    getParent(targetNode, "[data-content-source]");
  if (sourceNode) {
    trackData.board_source = `${page_nm}_${
      sub_page_nm || ""
    }_${sourceNode.getAttribute("data-content-source")}`;
  } else {
    trackData.board_source = `${page_nm}_${sub_page_nm || ""}`;
  }

  getCommonData(targetNode, trackData);
  const dist_code = getAttribute(targetNode, "data-board-dist-code");
  if (dist_code) {
    trackData.dist_code = dist_code;
  }

  merge(trackData, getFilter(page.page_nm, targetNode));

  if (page_nm === "搜索结果页") {
    getSearchData(trackData);
  }

  const search_word = getAttribute(targetNode, "data-search-word");
  if (search_word) {
    trackData.search_word = search_word;
  }

  if (page_nm === "采集详情页" && trackData.search_word) {
    getSearchData(trackData);
  }

  reporter(trackData);
}
